import React, { useEffect } from 'react';
import styles from './FreeTrialPlanSelection.less';
import classNames from 'classnames';
import { forNamespace } from '@trello/i18n';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary/ErrorBoundary';
import { Analytics } from '@trello/atlassian-analytics';
import { FreeTrialTestIds } from '@trello/test-ids';
import { PlanSelection } from './PlanSelection';
import { TrelloEnterpriseLearnMore } from './TrelloEnterpriseLearnMore';

type PlanSelectionType = 'try-business-class' | 'have-business-class';
type TrialLength = 14 | 30;

const format = forNamespace('upgrade-prompt-plan-selection-consolidated');

export interface FreeTrialPlanSelectionProps {
  orgId: string;
  type: PlanSelectionType;
  trialLength: TrialLength;
  cta: React.ReactNode;
  hideSecondaryCta?: boolean;
}

export const FreeTrialPlanSelection: React.FunctionComponent<FreeTrialPlanSelectionProps> = ({
  type,
  trialLength,
  cta,
  orgId,
  hideSecondaryCta = false,
}) => {
  useEffect(() => {
    Analytics.sendScreenEvent({
      name: 'planSelectionModal',
      containers: {
        organization: {
          id: orgId,
        },
      },
    });
  }, [orgId]);

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-mocha',
        feature: 'Free Trial Existing Team',
      }}
    >
      <div
        data-test-id={
          type === 'have-business-class'
            ? FreeTrialTestIds.HaveBCPlanSelection
            : FreeTrialTestIds.TryBCPlanSelection
        }
        className={styles.heading}
      >
        <h1>
          <img
            src={require('resources/images/moonshot/bc-sparkle.svg')}
            alt=""
            aria-hidden="true"
          />
          {format([type, 'headline'], { dayCount: trialLength })}
        </h1>
        <h2>{format([type, 'description'], { dayCount: trialLength })}</h2>
      </div>
      <PlanSelection trialLength={trialLength} />
      <div className={classNames(styles.actions, styles.actionsRebrand)}>
        {cta}
        <TrelloEnterpriseLearnMore hideOnSmallScreens />
      </div>
    </ErrorBoundary>
  );
};
